"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
var _Distpicker = _interopRequireDefault(require("@/components/Distpicker"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'regist',
  components: {
    upload: _two.default,
    VDistpicker: _Distpicker.default
  },
  data: function data() {
    return {
      platform: {},
      selType: [],
      step: 1,
      form: {},
      gid: this.$route.query.gid || '',
      soon: [{
        depend_type: 7,
        depend_name: '汽车充电桩'
      }, {
        depend_type: 8,
        depend_name: '售卖机'
      }, {
        depend_type: 9,
        depend_name: '洗车机'
      }, {
        depend_type: 10,
        depend_name: '摇摇车'
      }]
    };
  },
  mounted: function mounted() {
    this.get_platform_config();
  },
  methods: {
    /**
     * 获取站点配置
     */
    get_platform_config: function get_platform_config() {
      var _this = this;
      var params = {
        'agent_id': this.gid || this.config.default_agent_id
      };
      this.$get('commonapi/get_platform_config', params).then(function (res) {
        _this.platform = res;
      });
    },
    /**
     * 选择设备类型
     */
    selDevice: function selDevice(item) {
      if (this.selType.indexOf(item.depend_type) > -1) {
        this.selType.splice(this.selType.indexOf(item.depend_type), 1);
      } else {
        this.selType.push(item.depend_type);
      }
    },
    /**
     * 选择区域
     */
    selectCity: function selectCity(e) {
      this.form.province = e.province.value;
      this.form.city = e.city.value;
      this.form.county = e.area.value;
    },
    /**
     * 提交资料
     */
    editInfo: function editInfo() {
      var _this2 = this;
      var params = this.form;
      for (var i in this.selType) {
        params['depend_type_' + this.selType[i]] = 1;
      }
      this.loadObj = this.$loading({
        lock: true,
        text: '正在提交',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/ucenter/save_agent_self', params).then(function (res) {
        _this2.loadObj.close();
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        setTimeout(function () {
          location.href = '/home';
        }, 1000);
      }).catch(function (err) {
        _this2.loadObj.close();
      });
    }
  }
};